<template>
    <div class="flex-x center-x">
        <h2>Status: <span :style="{ color: StatusColour }" style="font-weight: bold;" id="hero-banner-status" v-text="Enabled"></span></h2>
        <button type="button" class="btn btn-warning mx-4" @click="this.Toggle()">Toggle</button>
    </div>
</template>

<script>

export default {

    data () {
        return {
            CurrentStatus: false
        }
    },

    props: ['status'],

    created () {
        this.CurrentStatus = this.status;
    },

    computed: {
        Enabled() {
            return this.CurrentStatus ? 'Enabled' : 'Disabled'
        },

        StatusColour () {
            return this.CurrentStatus ? 'green' : 'red'
        }
    },

    methods: {
        Toggle () {
            axios.post('/admin/hero/update_status', {
                status: this.CurrentStatus
            })
            .then( (response) => {
                this.CurrentStatus = response.data.status;
                window.Toast(`Hero Banner has been ${this.Enabled}!`);
            });
        }
    }

}
</script>